export default __webpack_public_path__ + "static/media/bannerDecoration.ffca88a7.png";